import React from "react";
import { classNames } from "../utils/classNames";
export var LeftCol = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "layout--panel" }, children));
};
export var CentreCol = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "layout--panel layout--center" }, children));
};
export var RightCol = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "layout--panel" }, children));
};
export var LayoutContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "layout--content content-container" }, children));
};
export var Page = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (React.createElement("div", { className: classNames("page", className) }, children));
};
